import generalUpload from "../_section/upload.class";
import dayjs from "dayjs";

export class userExistingMpiPolicyUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}

const template = {
    items: [{
        name: 'coverAmount', label: 'Amount of Cover', type: 'currency',
    }, {
        name: 'endDate', label: 'End Date', type: 'date', optional: true,
    }, {
        name: 'startDate', label: 'Or Start Date', type: 'date',optional: true,
    }, {
        name: 'termInYears', label: 'And Term', type: 'int',optional: true,
    }]
}

export class adminExistingMpiPolicyUpload extends userExistingMpiPolicyUpload {


    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (!this.values?.endDate && this.values?.startDate && this.values?.termInYears) {
            this.values.endDate = this.values.startDate.add(this.values.termInYears, 'year');
        }
        if (!this.values?.startDate && this.values?.endDate && this.values?.termInYears) {
            this.values.startDate = this.values.endDate.subtract(this.values.termInYears, 'year');
        }

        if (this.values.endDate) {
            this.setDateData({
                dated: this.values.startDate, expires: this.values.endDate,
            })
        }
    }
}
